import { useQuery } from "@tanstack/react-query";

import { authLogService } from "@/services/authLogService";

export function useMyAuthLogs(limit = 20) {
  return useQuery({
    queryKey: ["me", "auth-logs", limit],
    queryFn: () => authLogService.listMine(limit),
  });
}

export function useAdminAuthLogs(params?: { event_type?: string; success?: boolean }, enabled = true) {
  return useQuery({
    queryKey: ["admin", "auth-logs", params ?? {}],
    queryFn: () => authLogService.listAll({ ...params, limit: 100 }),
    enabled,
  });
}

export function useAuditErrorLogs(enabled = true) {
  return useQuery({
    queryKey: ["admin", "audit-error-logs"],
    queryFn: () => authLogService.listErrors({ limit: 100 }),
    enabled,
  });
}
